const MeasureUnitType = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "measurement_unit_type": "نوع وحدة القياس",

    // TOOLTIP
    "unit_type": "نوع الوحدة",

    // ERROR
    "error_name": "يرجى إدخال الاسم",
    "error_desc": "يرجى إدخال الوصف",
    "error_status": "يرجى تحديد الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",

}

export default MeasureUnitType;